import axios from 'axios';
import BaseApi from './base-api';
import numeral from 'numeral';

class ProjectsApi extends BaseApi {
  getProjects(filters) {
    let query = '';
    Object.keys(filters)
      .filter((filter) => filters[filter])
      .forEach((filter, index) => {
        if (index > 0) {
          query += '&';
        }
        query += `${filter}=${filters[filter]}`;
      });

    return axios
      .get(`${this.baseUrl}/projects?${query}`)
      .then((response) => {
        return {
          ok: true,
          projects: {
            content: response.data,
            total: numeral(response.headers['total']).value(),
            totalMyProjects: numeral(
              response.headers['total-my_projects']
            ).value(),
            totalPending: numeral(response.headers['total-pending']).value(),
            totalInProgress: numeral(
              response.headers['total-in_progress']
            ).value(),
            totalCancelled: numeral(
              response.headers['total-cancelled']
            ).value(),
            totalLost: numeral(response.headers['total-lost']).value(),
            totalPrecon: numeral(response.headers['total-precon']).value(),
            totalComplete: numeral(response.headers['total-complete']).value(),
            pageSize: numeral(response.headers['per-page']).value(),
          },
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getProjectsCount(filters) {
    let query = '';
    Object.keys(filters).forEach((filter, index) => {
      if (index > 0) {
        query += '&';
      }
      query += `${filter}=${filters[filter]}`;
    });

    return axios
      .get(`${this.baseUrl}/projects/count?${query}`)
      .then((response) => {
        return {
          ok: true,
          count: numeral(response.headers['total']).value(),
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getProject(projectId) {
    return axios
      .get(`${this.baseUrl}/projects/${projectId}`)
      .then((response) => {
        return {
          ok: true,
          project: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  dailyReportsReminder(id) {
    return axios
      .put(`${this.baseUrl}/projects/${id}/daily_reports_reminder`)
      .then((response) => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  createProject(values) {
    const data = this.projectParams(values);

    if (values.generalContractorId) {
      data['project']['general_contractor_id'] = values.generalContractorId;
    }

    return axios
      .post(`${this.baseUrl}/projects`, data)
      .then((response) => {
        return {
          ok: true,
          project: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateProject(id, values) {
    const data = this.projectParams(values);

    return axios
      .put(`${this.baseUrl}/projects/${id}`, data)
      .then((response) => {
        return {
          ok: true,
          project: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  projectParams(values) {
    return {
      project: {
        number: values.number,
        name: values.name,
        sq_footage: values.sqFootage,
        bid_due_date: values.bidDueDate,
        client_id: values.clientId,
        building_id: values.buildingId,
        status: values.status,
        termination_date: values.terminationDate,
        termination_reason: values.terminationReason,
        termination_category: values.terminationCategory,
        advanced_document_view: values.advancedDocumentView,
      },
    };
  }
}

export const projectsApi = new ProjectsApi();



// WEBPACK FOOTER //
// ./src/services/api/projects-api.js